export default __webpack_public_path__ + "static/media/conifer.13c27db9.jpg";